import type {
  ReviewFieldAction,
  ReviewFieldStatus,
  ReviewFieldValueType,
} from "v2/types/extractionReview.types";

export const REVIEW_STATUS = {
  PENDING: "pending",
  CONFLICT: "conflict",
  CONFIRMED: "confirmed",
  REJECTED: "rejected",
  FAILED: "failed",
  SAVED: "saved",
} as const satisfies Record<string, ReviewFieldStatus>;

export const REVIEW_ACTION = {
  CONFIRM: "confirm",
  REJECT: "reject",
  UNDO: "undo",
  CHOOSE: "choose",
} as const satisfies Record<string, ReviewFieldAction>;

export const FIELD_TYPE = {
  DATE: "date",
  OBJECT: "object",
} as const satisfies Record<string, ReviewFieldValueType>;

// Candidate sentinel: a "choose" with this uuid means "none of these" → server rejects.
export const NONE_OF_THESE = "__none__";
